module.exports = __webpack_public_path__ + "static/media/souse_hot_spices.00663ac0.png";